import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { ApiCMSRequest } from "data/ApiCMS";
import { Sites } from "data/utils/globals";
import { useCallback } from "react";
import { SchemaData } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { useNavigate } from "react-router-dom";

export default function useCreate() {
  const navigate = useNavigate();

  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const data = state?.data;

    const endDate = new Date(data.endDate)
    const startDate = new Date(data.startDate)

    if (endDate < startDate) {
      throw {
        message: "A Data de final não pode ser antes que a Data inicial",
        errors: [
          {
            instancePath: "/endDate",
            message: "A Data de final não pode ser antes que a Data inicial",
            schemaPath: "/endDate",
            keyword: "endDate",
            params: {},
          },
        ],
      };
    }

    const response = await ApiCMSRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: {
        data,
      },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data) {
      throw new Error("Ops. Sem resposta!");
    }

    navigate(`${Sites.UNIFTEC.path}/calendarios/${response.data.data.createCalendar.id}`);

    return response;
  }, []);

  return {
    handleSave,
  };
}
